/**
 * COA mockup preview — fetches real coa-print-preview section HTML on variant change.
 * Does not modify cart forms or variant IDs.
 */
(function () {
  var SECTION_ID = 'coa-print-preview';
  var pendingFetches = {};

  function getAiGenId(trustRoot) {
    return trustRoot.dataset.coaMockupRoot || '';
  }

  function getModalDialog(trustRoot) {
    var id = getAiGenId(trustRoot);
    if (!id) return null;
    return document.getElementById('CoaMockupModal-' + id);
  }

  function getModalContent(trustRoot) {
    var id = getAiGenId(trustRoot);
    if (!id) return null;
    return document.querySelector('[data-coa-mockup-modal="' + id + '"]');
  }

  function getProductRoot(trustRoot) {
    var id = getAiGenId(trustRoot);
    if (id) {
      var el = document.querySelector('product-single-column-' + id);
      if (el) return el;
    }
    return trustRoot.parentElement || document;
  }

  function getActiveSelectKey(productRoot) {
    var activeTab = productRoot.querySelector('[data-tab].active');
    if (activeTab && activeTab.getAttribute('data-tab')) {
      return activeTab.getAttribute('data-tab');
    }
    return productRoot.dataset.coaLastSelectKey || 'metal';
  }

  function getActiveSelect(productRoot, selectKey) {
    return productRoot.querySelector('[data-variant-select="' + selectKey + '"]');
  }

  function resolveVariantId(productRoot) {
    var selectKey = getActiveSelectKey(productRoot);
    var select = getActiveSelect(productRoot, selectKey);
    if (!select || !select.value) return null;
    return parseInt(select.value, 10);
  }

  function getMount(trustRoot) {
    var content = getModalContent(trustRoot);
    if (!content) return null;
    return content.querySelector('[data-coa-preview-mount]');
  }

  function isModalOpen(trustRoot) {
    var dialog = getModalDialog(trustRoot);
    return dialog && dialog.hasAttribute('open');
  }

  function fetchPreview(trustRoot) {
    var content = getModalContent(trustRoot);
    var mount = getMount(trustRoot);
    if (!content || !mount) return Promise.resolve();

    var productUrl = content.getAttribute('data-product-url');
    var productRoot = getProductRoot(trustRoot);
    var variantId = resolveVariantId(productRoot);

    if (!productUrl || !variantId) {
      mount.innerHTML = '<p class="coa-mockup-modal__empty">Select a size to preview the certificate.</p>';
      mount.setAttribute('aria-busy', 'false');
      return Promise.resolve();
    }

    var fetchKey = getAiGenId(trustRoot) + ':' + variantId;
    if (pendingFetches[fetchKey]) {
      return pendingFetches[fetchKey];
    }

    mount.setAttribute('aria-busy', 'true');
    mount.innerHTML = '<p class="coa-mockup-modal__loading">Loading certificate preview…</p>';

    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', SECTION_ID);
    url.searchParams.set('variant', String(variantId));

    pendingFetches[fetchKey] = fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var wrap = doc.querySelector('.coa-print-preview-wrap');
        if (!wrap) {
          var sheet = doc.getElementById('coa-print-sheet');
          if (sheet && sheet.parentElement) {
            wrap = sheet.parentElement;
          }
        }

        if (!wrap) {
          mount.innerHTML = '<p class="coa-mockup-modal__empty">Certificate preview unavailable.</p>';
          return;
        }

        mount.innerHTML = wrap.classList.contains('coa-print-preview-wrap')
          ? wrap.outerHTML
          : '<div class="coa-print-preview-wrap">' + wrap.outerHTML + '</div>';

        if (typeof window.initCoaPrintQr === 'function') {
          window.initCoaPrintQr(mount);
        }
      })
      .catch(function (err) {
        console.warn('[coa-mockup] preview fetch failed', err);
        mount.innerHTML = '<p class="coa-mockup-modal__empty">Unable to load certificate preview. Please try again.</p>';
      })
      .finally(function () {
        mount.setAttribute('aria-busy', 'false');
        delete pendingFetches[fetchKey];
      });

    return pendingFetches[fetchKey];
  }

  function fetchPreviewIfOpen(trustRoot) {
    if (isModalOpen(trustRoot)) {
      fetchPreview(trustRoot);
    }
  }

  function bindRoot(trustRoot) {
    if (trustRoot.dataset.coaMockupBound) return;
    trustRoot.dataset.coaMockupBound = 'true';

    var productRoot = getProductRoot(trustRoot);
    productRoot.dataset.coaLastSelectKey = productRoot.dataset.coaLastSelectKey || 'metal';

    productRoot.querySelectorAll('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        productRoot.dataset.coaLastSelectKey = select.getAttribute('data-variant-select') || '';
        fetchPreviewIfOpen(trustRoot);
      });
    });

    productRoot.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          fetchPreviewIfOpen(trustRoot);
        });
      });
    });

    var dialog = getModalDialog(trustRoot);
    if (dialog) {
      var observer = new MutationObserver(function () {
        if (dialog.hasAttribute('open')) {
          fetchPreview(trustRoot);
        }
      });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    var opener = trustRoot.querySelector('modal-opener[data-modal="#CoaMockupModal-' + getAiGenId(trustRoot) + '"]');
    if (opener) {
      var btn = opener.querySelector('button');
      if (btn) {
        btn.addEventListener('click', function () {
          window.requestAnimationFrame(function () {
            fetchPreview(trustRoot);
          });
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-coa-mockup-root]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CoaMockupPreview = { fetchPreview: fetchPreview, fetchPreviewIfOpen: fetchPreviewIfOpen };
})();
